import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ItemComponent from '../../../../core/infraestructure/ItemComponent';
import SimulatorOfficialDetailViewModel from '../../../../core/features/simulator/viewmodels/SimulatorOfficialDetailViewModel';

export default {
    extends: ItemComponent,
    data() {
        return {
            viewModel: null,
            questionSelected: null,
            linkedList: null,
            isLoading: false,
        };
    },
    props: {
        currentSection: {
            required: true,
            type: Object
        },
        simulatorId: {
            required: true,
            type: String
        }
    },
    mounted() {
        // this.$root.$on('onSubmitedSimulator', this.onSubmitSimulator)
    },
    beforeDestroy() {
        // this.$root.$off('onSubmitedSimulator', this.onSubmitSimulator);
    },
    created() {
        this.viewModel = new SimulatorOfficialDetailViewModel(this);
        this.onActive()
    },
    methods: {
        onActive() {
            this.linkedList = this.viewModel.initLinkedList(this.currentSection.simulatorSectionQuestions);
            this.questionSelected = this.linkedList.get(0)
            if(this.questionSelected) {
                this.viewModel.changeQuestion({
                    simulatorId: this.simulatorId,
                    sectionId: this.currentSection.id,
                    simulatorQuestionId: this.questionSelected.value.id
                })
            }
        },
        onNextQuestion() {
            this.isLoading = true
            if(this.questionSelected.next) {
                setTimeout(() => {
                    this.questionSelected = this.viewModel.nextNode(this.questionSelected)
                    this.viewModel.changeQuestion({
                        simulatorId: this.simulatorId,
                        sectionId: this.currentSection.id,
                        simulatorQuestionId: this.questionSelected.value.id
                    })
                }, 200);
            }
        },
        onPrevQuestion() {
            if (this.questionSelected.prev) {
                setTimeout(() => {
                    this.questionSelected = this.viewModel.prevNode(this.questionSelected)
                    this.viewModel.changeQuestion({
                        simulatorId: this.simulatorId,
                        sectionId: this.currentSection.id,
                        simulatorQuestionId: this.questionSelected.value.id
                    })
                }, 200);
            }
        },
        onChangeQuestionResponse(response) {
            setTimeout(() => {
                this.isLoading = false;
                EventBus.$emit('onChangeQuestion', response.data);
            }, 100);
        },
        onFinishSection() {
            this.isLoading = true;
            this.questionSelected =  null
            this.viewModel.getSectionStatus(this.simulatorId, this.currentSection.id)
        },
        onGetSectionStatusResponse(response) {
            setTimeout(() => {
                this.isLoading = false;
                EventBus.$emit('onFinishSection', response.data);
            }, 400);
        },
        isFinalQuestion() {
            return (!this.questionSelected.next)
        }
    },
};